let email_regex = new RegExp(/^(([^<>()[\]\\#.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|("."))([a-z0-9]@+[a-z0-9])((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
let pass_regex = new RegExp(/^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/);

export const email = (email) => {
    return email && email_regex.test(email) ? '' : 'Please enter a valid email address';
}

export const password = (password) => {
    return password && pass_regex.test(password) ? '' : 'Password must contain lowercase, uppercase, numeric and special characters and no spaces.'
}
export const required = (value) => {
    value = value ? value.toString() : value;
    return value && value.trim().length ? '' : 'Field is required';
}

export const passwordMatch = (password, allValues) => {
    return password !== allValues.password ? 'Passwords do not match' : undefined
}

export const maxLength = max => (value) => {
    return value && value.length > max
      ?  `Must be ${max} characters or less` : undefined
}

export const minLength = min => (value) => {
    return value && value.length < min
      ?  `Must be ${min} characters or more` : undefined
}

export const number = (value) => {
    return value && value > 0  ? undefined :  'Quantity required';
}

export const sameName = (array, name) => {
    return (array.map(function(e) { return e.name; }).indexOf(name) > -1)
}

export const sameNameCity = (array, name) => {
    return (array.map(function(e) { return e.city + ', ' + e.state; }).indexOf(name) > -1)
}

export const maxLength16 = maxLength(16);
export const minLength8 = minLength(8);
